import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Title, Group, SingleSelectDropDown, Loader } from '@insticator/insticator-ui';
import { updateCurrentPaymentTerm } from "../../../../../../state/slices/account";
import injectSheet from 'react-jss';
import styles from './paymentterm_styles';

const paymentTerms = [
    {name: "Net 30", value: "Net30"},
    {name: "Net 45", value: "Net45"},
    {name: "Net 60", value: "Net60"},
]

const PaymentTermSection = injectSheet(styles)((props) => {
    const dispatch = useDispatch();
    const { companyInfoUpdateStatus } = useSelector((state) => state.account);
    const { current, updating } = useSelector((state) => state.account.paymentTerm);
    const [currentTerm, setCurrentTerm] = useState(updating || current);

    useEffect(() => {
        setCurrentTerm(updating || current)
    }, [current, updating])

    return (
        <div className={`paymenttermsection ${props.classes.paymenttermsection}`}>
            <Group name={'paymentterm'}>
                <Title>
                    <h2>Payment term</h2>
                    <p>This will indicate how often the publisher will be paid out for their portion of the
                        revenue share.</p>
                </Title>
                {
                    companyInfoUpdateStatus === 'pending' ? <Loader/> :
                        <SingleSelectDropDown
                            searchable={false}
                            onSelect={e => {
                                setCurrentTerm(e.value)
                                dispatch(updateCurrentPaymentTerm(e.value))
                            }}
                            items={paymentTerms}
                            selected={paymentTerms.find(term => term.value === currentTerm)}
                            name={currentTerm}
                        />
                }
            </Group>
        </div>
    )
});

export default PaymentTermSection;
